import React, { useState } from "react";
import {
    FormGroup,
    FormControl,
    ControlLabel
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import "./Signup.css";
import { getCurrentUser, updatePassword } from 'aws-amplify/auth';

export default function PasswordChange(props) {
    const [passwordChanged, setPasswordChanged] = useState(false);

    const [fields, handleFieldChange] = useFormFields({
        email: "",
        password: "",
        confirmPassword: "",
        oldPassword: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    function validateForm() {
        return (
            fields.oldPassword.length > 0 &&
            fields.password.length > 0 &&
            fields.password === fields.confirmPassword
        );
    }

    async function handleSubmit(event) {
        event.preventDefault();

        setIsLoading(true);

        getCurrentUser()
            .then((user) => {
                return updatePassword({
                    oldPassword: fields.oldPassword,
                    newPassword: fields.password
                });
            })
            .then((data) => {
                setIsLoading(false);
                setPasswordChanged(true);
            })
            .catch((err) => {
                alert(err.message);
                setIsLoading(false);
                setPasswordChanged(false);
            });
    }

    function renderConfirmationForm() {
        return (
            <div>
                <p>
                    Password changed successfully
                </p>
            </div>
        );
    }

    function renderPasswordChangeForm() {
        return (
            <form onSubmit={handleSubmit}>
                <FormGroup controlId="oldPassword" bsSize="large">
                    <ControlLabel>Old Password</ControlLabel>
                    <FormControl
                        type="password"
                        onChange={handleFieldChange}
                        value={fields.oldPassword}
                    />
                </FormGroup>
                <FormGroup controlId="password" bsSize="large">
                    <ControlLabel>New Password</ControlLabel>
                    <FormControl
                        type="password"
                        value={fields.password}
                        onChange={handleFieldChange}
                    />
                </FormGroup>
                <FormGroup controlId="confirmPassword" bsSize="large">
                    <ControlLabel>Confirm Password</ControlLabel>
                    <FormControl
                        type="password"
                        onChange={handleFieldChange}
                        value={fields.confirmPassword}
                    />
                </FormGroup>
                <LoaderButton
                    block
                    type="submit"
                    bsSize="large"
                    isLoading={isLoading}
                    disabled={!validateForm()}
                >
                    Change password
                </LoaderButton>
            </form>
        );
    }
    return (
        <div className="Signup">
            {passwordChanged === true ? renderConfirmationForm() : renderPasswordChangeForm()}
        </div>
    );
}